import { render, staticRenderFns } from "./MonthlyBalance.vue?vue&type=template&id=12a266c0&scoped=true"
import script from "./MonthlyBalance.vue?vue&type=script&lang=js"
export * from "./MonthlyBalance.vue?vue&type=script&lang=js"
import style0 from "./MonthlyBalance.vue?vue&type=style&index=0&id=12a266c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a266c0",
  null
  
)

export default component.exports